import StartRequestBase from "../components/StartRequestBase";

const VermostOutsiderStartBondRequestHistoric = () => (
  <StartRequestBase variant="historic" />
);

export default VermostOutsiderStartBondRequestHistoric;
